<template>
    <div class="sessionOver">
        <v-overlay
            :value="isSessionOver"
        >
            <v-card>
                <v-card-title>
                    <v-icon>
                        fas fa-exclamation-triangle
                    </v-icon>
                    Session Expired
                </v-card-title>
                <v-card-text>
                    Your session has expired.
                    <br>
                    Please log in again to continue with your investment journey
                </v-card-text>
                <v-card-actions>
                    <button class="btn btn-secondary w-150px"  @click="redirectToLogin"> Login </button>
                </v-card-actions>
            </v-card>
        </v-overlay>
    </div>
</template>
<script>

export default {
    name: 'SessionOver',
    data () {
        return {
            isSessionOver: false
        }
    },
    watch: {
        '$store.state.isSessionOver': {
            handler (newValue, oldValue) {
                this.isSessionOver = newValue
                if (newValue === true) {
                    this.$store.dispatch('logout')
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        redirectToLogin () {
            this.$router.push('/login')
        }
    }
}
</script>

<style lang="scss" scoped>

.v-card {
    padding: 12px;
    background: white !important;
    color: $primary !important;
    margin: 0px 24px;
}

.v-card__title {
    .v-icon.v-icon {
        color: #FBC100;
        padding: 8px 8px 8px 0px;
    }
}

.v-card__text {
    color: $primary !important;
}

.v-card__actions{
    justify-content: flex-end;
}
</style>
